module.exports = __webpack_public_path__ + "static/img/houyiyichang@2x.2a311234.png";